/* FULLHED Klean product controller v6: shade, Refill Plan tiers, applicator add on (pre selected),
   single purchase packs, Hello Klean style summary, sticky CTA visible whenever the main button is not. */
(function () {
  var track = window.fhTrack || function () {};
  function fmt(c) { return 'A$' + (Math.round(c) / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function initGallery(root) {
    var trk = root.querySelector('.fh-gallery__track');
    var slides = root.querySelectorAll('.fh-gallery__slide');
    var thumbs = root.querySelectorAll('.fh-gallery__thumb');
    var strip = root.querySelector('.fh-gallery__thumbs');
    var i = 0;
    if (!slides.length) return;
    function setActive(n) {
      i = (n + slides.length) % slides.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (strip && thumbs[i]) {
        var s = strip.getBoundingClientRect(), t = thumbs[i].getBoundingClientRect();
        if (t.left < s.left || t.right > s.right) strip.scrollBy({ left: (t.left - s.left) - 4, behavior: 'smooth' });
      }
    }
    function go(n) {
      var idx = ((n % slides.length) + slides.length) % slides.length;
      if (trk && slides[idx]) trk.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('.fh-gallery__nav--prev'), next = root.querySelector('.fh-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (trk) {
      var tm;
      trk.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () {
          var w = trk.clientWidth; if (!w) return;
          var idx = Math.round(trk.scrollLeft / w);
          if (idx !== i) setActive(idx);
        }, 60);
      }, { passive: true });
    }
    window.fhGallery = { go: go };
  }

  function init(root) {
    var data = JSON.parse(root.querySelector('[data-fhk-data]').textContent);
    var L = data.labels, P = data.prices;
    var firstSub = root.querySelector('.fhk-plans--sub [data-fhk-offer]');
    var addon = root.querySelector('[data-fhk-addon]');
    var state = {
      shade: data.defaultShade,
      offer: (data.hasSub && firstSub) ? firstSub.dataset.fhkOffer : 'onetime',
      addon: !!(addon && data.applicator)
    };
    var swatches = root.querySelectorAll('[data-fhk-shade]');
    var plans = root.querySelectorAll('[data-fhk-offer]');
    var shadeName = root.querySelector('[data-fhk-shade-name]');
    var summary = root.querySelector('[data-fhk-summary]');
    var cta = root.querySelector('[data-fhk-atc]');
    var ctaLabel = root.querySelector('[data-fhk-cta-label]');
    var ctaPrice = root.querySelector('[data-fhk-cta-price]');
    var note = root.querySelector('[data-fhk-note]');
    var step2 = root.querySelector('[data-fhk-step2]');
    var sticky = root.querySelector('[data-fh-sticky]');
    var stickyLabel = root.querySelector('[data-fhk-sticky-label]');
    var stickyCtaPrice = root.querySelector('[data-fh-sticky-cta-price]');
    var stickyBtn = root.querySelector('[data-fh-atc-sticky]');

    function isSub(o) { return o && o.indexOf('sub-') === 0; }
    function planEl(o) { return root.querySelector('[data-fhk-offer="' + o + '"]'); }

    function totals() {
      var o = state.offer, rows = [], was = null, now = 0;
      if (isSub(o)) {
        var el = planEl(o), qty = +el.dataset.qty, total = +el.dataset.total, weeks = el.dataset.weeks;
        rows.push([L.fibers + ' (' + weeks + ' ' + L.weekSupply + ')', fmt(total)]);
        if (state.addon && data.applicator) rows.push([L.applicator, fmt(P.app)]);
        rows.push([L.shipping, L.free]);
        now = total + (state.addon ? P.app : 0);
        var full = P.one * qty + (state.addon ? P.app : 0);
        was = full > now ? full : null;
      } else if (o === 'starter') {
        rows.push([L.starter, fmt(P.starter)]);
        rows.push([L.shipping, L.paidShipping]);
        now = P.starter;
        was = P.starterWas > P.starter ? P.starterWas : null;
      } else if (o === 'b2g1') {
        rows.push([L.triple + ' (3 ' + L.bottles + ')', fmt(P.one * 2)]);
        rows.push([L.shipping, L.free]);
        was = P.one * 3; now = P.one * 2;
      } else {
        rows.push([L.one, fmt(P.one)]);
        rows.push([L.shipping, L.paidShipping]);
        now = P.one;
      }
      return { rows: rows, was: was, now: now };
    }

    function render() {
      var t = totals();
      var html = t.rows.map(function (r) {
        return '<div class="fhk-row"><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>';
      }).join('');
      html += '<div class="fhk-row fhk-total"><span>' + esc(L.total) + '</span><span>' + (t.was ? '<s>' + fmt(t.was) + '</s>' : '') + '<b>' + fmt(t.now) + '</b></span></div>';
      if (summary) summary.innerHTML = html;
      var sub = isSub(state.offer);
      var label = sub ? L.ctaSub : L.ctaOne;
      if (ctaLabel) ctaLabel.textContent = label;
      if (ctaPrice) ctaPrice.textContent = fmt(t.now);
      if (stickyLabel) stickyLabel.textContent = label;
      if (stickyCtaPrice) stickyCtaPrice.textContent = fmt(t.now);
      if (note) note.textContent = sub ? L.noteSub : L.noteOne;
      if (step2) step2.textContent = sub ? step2.dataset.labelSub : step2.dataset.labelOne;
    }

    function syncAddon() {
      if (!addon) return;
      addon.classList.toggle('is-on', state.addon);
      addon.setAttribute('aria-checked', state.addon ? 'true' : 'false');
    }

    function selectShade(shade, via) {
      if (!data.core[shade]) return;
      state.shade = shade;
      swatches.forEach(function (el) {
        var on = el.dataset.fhkShade === shade;
        el.closest('.fhk-swatch').classList.toggle('is-selected', on);
        if (on) el.checked = true;
      });
      if (shadeName) shadeName.textContent = shade;
      root.querySelectorAll('[data-fhk-bottle]').forEach(function (s) { if (!s.dataset.touched) s.value = shade; });
      var v = data.core[shade];
      if (v && v.mediaIndex != null && window.fhGallery) window.fhGallery.go(v.mediaIndex);
      try { localStorage.setItem('fh_shade', shade); } catch (e) {}
      track('fh_shade_select', { shade: shade, sku: v ? v.sku : null, via: via || 'selector' });
      render();
    }

    function selectOffer(offer) {
      if (plans.length && !planEl(offer)) return;
      state.offer = offer;
      plans.forEach(function (el) {
        var on = el.dataset.fhkOffer === offer;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      root.classList.toggle('is-onetime', !isSub(offer));
      track('fh_offer_select', { offer: offer });
      render();
    }

    swatches.forEach(function (el) { el.addEventListener('change', function () { selectShade(el.dataset.fhkShade); }); });
    plans.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('select, a, button')) return;
        selectOffer(el.dataset.fhkOffer);
      });
      el.addEventListener('keydown', function (e) {
        if (e.target !== el) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOffer(el.dataset.fhkOffer); }
      });
    });
    if (addon) {
      var toggle = function () {
        state.addon = !state.addon;
        syncAddon();
        track('fh_addon_toggle', { on: state.addon });
        render();
      };
      addon.addEventListener('click', toggle);
      addon.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    }
    root.querySelectorAll('[data-fhk-bottle]').forEach(function (s) { s.addEventListener('change', function () { s.dataset.touched = '1'; }); });
    root.querySelectorAll('[data-fhk-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        selectOffer(b.dataset.fhkMode === 'onetime' ? 'onetime' : (firstSub ? firstSub.dataset.fhkOffer : 'onetime'));
        var box = root.querySelector('[data-fhk-plans-anchor]');
        if (box && box.getBoundingClientRect().top < 60) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    function attrs() {
      var a = { 'Shade': state.shade, 'Offer': isSub(state.offer) ? 'refill-plan' : state.offer };
      try {
        var q = JSON.parse(localStorage.getItem('fh_quiz') || '{}');
        Object.keys(q).forEach(function (k) { a['Quiz: ' + k] = q[k]; });
        var em = localStorage.getItem('fh_email'); if (em) a['Quiz email'] = em;
      } catch (e) {}
      return a;
    }
    function busy(on) { [cta, stickyBtn].forEach(function (b) { if (b) { b.disabled = on; b.classList.toggle('is-loading', on); } }); }

    async function addToCart() {
      busy(true);
      var o = state.offer, core = data.core[state.shade], items = [], redirect = data.cartUrl;
      if (isSub(o)) {
        var el = planEl(o);
        items.push({ id: core.id, quantity: +el.dataset.qty, selling_plan: +el.dataset.plan });
        if (state.addon && data.applicator) items.push({ id: data.applicator, quantity: 1 });
      } else if (o === 'starter') {
        var kit = data.starter[state.shade] || data.starter[data.defaultShade];
        if (kit) items.push({ id: kit.id, quantity: 1 });
      } else if (o === 'b2g1') {
        var sels = root.querySelectorAll('[data-fhk-bottle]');
        if (sels.length) sels.forEach(function (s) { var v = data.core[s.value] || core; items.push({ id: v.id, quantity: 1 }); });
        else items.push({ id: core.id, quantity: 3 });
        if (data.discount) redirect = '/discount/' + encodeURIComponent(data.discount) + '?redirect=' + data.cartUrl;
      } else {
        items.push({ id: core.id, quantity: 1 });
      }
      try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs() }) });
        var res = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!res.ok) throw new Error('cart add ' + res.status);
        track('fh_add_to_cart', { offer: o, shade: state.shade, items: items });
        busy(false);
        if (window.fhCart && !(o === 'b2g1' && data.discount)) window.fhCart.open();
        else window.location.href = redirect;
      } catch (e) { busy(false); console.error('[FH] add to cart failed', e); }
    }
    if (cta) cta.addEventListener('click', addToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    if (sticky && cta && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0.1 }).observe(cta);
    }

    var params = new URLSearchParams(window.location.search);
    var pre = params.get('shade');
    try { pre = pre || localStorage.getItem('fh_shade'); } catch (e) {}
    if (params.get('plan') === 'onetime') state.offer = 'onetime';
    if (params.get('plan') === 'bundle' && planEl('b2g1')) state.offer = 'b2g1';
    syncAddon();
    selectOffer(state.offer);
    selectShade(pre && data.core[pre] ? pre : state.shade);
    window.fhSelectShade = function (s) { selectShade(s, 'quiz'); };
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-fhk-pdp]');
    if (root) { initGallery(root); init(root); }
  });
})();
